const Joi = require("joi");

const changePasswordSchema = (data) => {
  const schema = Joi.object({
    newPassword: Joi.string()
    .pattern(
      new RegExp(
        /^(?=.*\d)(?=.*[a-z])[\w~@#$%^&*+=`|{}:;!.?"()\[\]-]{8,50}$/
      ) 
    )
    .required()
    .messages({
      "string.pattern.base":
        "Password should contain letter, numbers and minimum 8 characters.",
      "any.required": "Please enter password.",
      "string.empty": "Please enter password.",
    }),

    confirmPassword: Joi.string()
    .valid(Joi.ref("newPassword"))
    .required()
    .messages({
      "any.only": "Password and Confirm Password must match.",
      "any.required": "Please enter confirm password.",
      "string.empty": "Please enter confirm password.",
    }),

  }).unknown(true);
  
  return schema.validate(data, { abortEarly: false });
};


module.exports = changePasswordSchema;